import React from 'react'
import { Link } from 'react-router-dom';
function Herosection1() {
  const gototop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  return (
    <>
      <section className="hero-banner position-relative custom-py-1 hero-shape1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-5 col-xl-6 order-lg-1 mb-8 mb-lg-0">
              {/* <!-- Image --> */}
              <picture>
                <source media="(max-width: 768px)" srcSet={require("../../assets/images/inspectiver/01_mobile.webp")} />
                <source media="(min-width: 769px)" srcSet={require("../../assets/images/inspectiver/01_desktop.webp")} />
                <img
                  className="img-fluid"
                  src={require("../../assets/images/inspectiver/01_desktop.webp")}
                  alt="Inspectiver"
                />
              </picture>
            </div>
            <div className="col-12 col-lg-7 col-xl-6">
              <h1 className="mb-5" style={{ fontSize: "2.5rem" }}>Pre-Purchase Car Inspections at the Vehicle's Location</h1>
              <Link className="btn btn-dark" aria-label="Order a pre-purchase car inspection" to="quotation">Order Your Inspection</Link>
              <blockquote className="mt-5 mb-0 ps-3 border-start border-primary">
                {/* <!-- Text --> */}
                <p className="lead mb-2 font-w-6">
                  Found your dream car?

                </p>
                <p className="lead mb-2">Share the details with us and get a professional pre-purchase inspection at the car's location so you can buy with confidence.</p>
                <p className="lead mb-0">
                  Starting at just <mark><strong><b>$139.00</b></strong></mark>
                </p>
              </blockquote>
            </div>
          </div>
          {/* <!-- / .row --> */}
        </div>
        {/* <!-- / .container --> */}
      </section>
    </>
  )
}

export default Herosection1
